// extracted by mini-css-extract-plugin
export default {"container":"JJ-z","dimension":"KJ-z","dimensionLabels":"LJ-z"};